import React, { useEffect, useState, useRef } from 'react'
import H1Title from '../h1-title/H1Title'
import './Hero.css'
import heroBg from '../../assets/images/hero_bg.png'
import FilterLocation from "../filter-location/FilterLocation"
import { buildFiltersFromProjects, filterProjects, isEmpty } from '../../services/filters/filters'
import { useDispatch, useSelector } from 'react-redux'
import {
  setFilterChangedId,
  setFilterChoices,
  setSeasonalFilterRdx,
  setSrcFilters,
  setTempFilters
} from '../../services/store/GenericReducer'
import FilterGeneric from '../filter-generic/FilterGeneric'
import { ReactComponent as HandIcon } from '../../assets/images/svg/hand.svg'
import { ReactComponent as HandsTogetherIcon } from '../../assets/images/svg/hands_together.svg'
import CommitmentIcon from '../../assets/images/svgComp/CommitmentIcon'
import CampusIcon from '../../assets/images/svgComp/CampusIcon'
import { isJsonStr } from '../../services/general-utils/generalUtils'
import FilterAmount from '../filter-amount/FilterAmount'
import AmountIcon from '../../assets/images/svgComp/AmountIcon'
import { updateUrlWithFilters, getFiltersFromUrl } from '../../utils/urlFilters'



export default function Hero(props) {

  const store = useSelector(state => state.reducer)
  const dispatch = useDispatch()
  const [clearFilterLabel, setClearFilterLabel] = useState(0)

  useEffect(() => {
      init()
  }, [store.partner])

  const init = () => {
    // Build the base filter structure from API filters
    let filterChoices = {}
    Array.isArray(props.filters) && props.filters.map(item => {
      let specialFilterTitle = ""
      if(item.filterTypeID === 11){
        let filterDetails = item.filterTypeID === 11 && isJsonStr(item.filterDetails) && JSON.parse(item.filterDetails)
        specialFilterTitle = Array.isArray(filterDetails.filterKeyValues) &&
            filterDetails.filterKeyValues.length > 1 &&
            filterDetails.filterKeyValues[1].Value
      }

      filterChoices[item.filterTypeID] = {
        filterTypeID: item.filterTypeID,
        title: item.filterTypeID === 11 && specialFilterTitle ? specialFilterTitle : item.title,
        choice: false
      }
    })

    // Get URL filters directly (in case store hasn't updated yet - e.g., incognito mode)
    const urlFilters = getFiltersFromUrl()

    // Merge with existing filterChoices (from store or URL)
    // URL filters take priority, then store filters
    const existingChoices = store.filterChoices || urlFilters
    if (existingChoices) {
      Object.keys(existingChoices).forEach(key => {
        if (existingChoices[key]?.choice) {
          filterChoices[key] = {
            ...filterChoices[key],
            ...existingChoices[key]
          }
        }
      })
    }

    // Also merge URL filters if store already has other filters (ensure URL filters are preserved)
    if (urlFilters && store.filterChoices) {
      Object.keys(urlFilters).forEach(key => {
        if (urlFilters[key]?.choice) {
          filterChoices[key] = {
            ...filterChoices[key],
            ...urlFilters[key]
          }
        }
      })
    }

    dispatch(setFilterChoices(filterChoices))

    let filters = !isEmpty(store.partner) && store.allProjects && setFiltersFromProjects(store.allProjects, props.filters, store, dispatch)
    if(!isEmpty(filters) && !isEmpty(store.partner)){
      dispatch(setTempFilters(filters))
      dispatch(setSrcFilters(filters))
    }
  }

  const setFiltersFromProjects = (projects, apiFilters, store, dispatch) => {
      return buildFiltersFromProjects(projects, store, dispatch)
  }

  const updateFilterChoices = (filterTypeID, choice) => {
    if(filterTypeID !== undefined && store.filterChoices){
      let filtersObj = {...store.filterChoices}
      let final = {...filtersObj, [filterTypeID]: {...filtersObj[filterTypeID], choice: choice}}
      dispatch(setFilterChoices(final))
      if (choice && !store.filterChangedId.includes(filterTypeID)) {
        dispatch(setFilterChangedId([...store.filterChangedId, filterTypeID]))
      }
    }
  }

  const clearFilters = () => {
    let filtersObj = {...store.filterChoices}
    Object.keys(filtersObj).forEach(function(key, index) {
      if(filtersObj[key].choice){
        let x = {...filtersObj[key], choice: false}
        filtersObj[key] = x
      }
    })
    dispatch(setFilterChoices(filtersObj))
    dispatch(setFilterChangedId([]))
    setClearFilterLabel(prev => prev + 1)
  }

  const setSeasonalFilter = (e) => {
    let filterValue = {...store.seasonalFilter, value: e.target.checked}
    e.target && dispatch(setSeasonalFilterRdx(filterValue))
    if(store.filterChoices){
      let filtersObj = {...store.filterChoices}
      let final = {...filtersObj, 555: {...filtersObj[555], filterTypeID: 555, title: "חיפוש", choice: filterValue.value}}
      dispatch(setFilterChoices(final))
    }
  }

  useEffect(() => {
    let filters = !isEmpty(store.partner) && store.displayProjects && setFiltersFromProjects(store.displayProjects, props.filters, store, dispatch)
    if(!isEmpty(filters) && !isEmpty(store.partner)){
      dispatch(setTempFilters(filters))
      dispatch(setSrcFilters(filters))
    }
  }, [store.displayProjects])

  // Track if this is the initial mount to avoid updating URL from localStorage filters
  const isInitialMount = useRef(true)

  useEffect(() => {
    // Always run filterProjects when filterChoices changes (including when clearing filters)
    if (store.filterChoices && store.allProjects?.length > 0) {
      filterProjects(store, dispatch)
    }

    // Sync URL with filter choices (skip initial mount to let URL filters be applied first)
    if (!isInitialMount.current && store.filterChoices) {
      updateUrlWithFilters(store.filterChoices)
    }
    isInitialMount.current = false
  }, [store.filterChoices])

  return (
    <section className="main-section" id="first-content-section" style={{backgroundImage: `url(${heroBg})`}}>
        <div className="content-container">
            <H1Title title={props.partner.partnerConfig.heroTitle ? props.partner.partnerConfig.heroTitle : "התנדבות בהתאמה אישית לעובדי בנק הפועלים"}/>
            <h2>{props.partner.partnerConfig.heroSubTitle}<br/>{props.partner.partnerConfig.heroMessage}</h2>
            <form action="">
                <h3>{props.partner.partnerConfig.findProjectMessage}</h3>
                {store.seasonalFilter.display && <label htmlFor="checkbox" className="checkbox-slider">
                    {store.filterChoices.hasOwnProperty(11) && store.filterChoices[11]?.title}
                    <input type="checkbox" id="checkbox" name="filter" checked={store.seasonalFilter.value} onChange={(e) => setSeasonalFilter(e)} value="התנדבות לקיץ" data-param-name="filter" data-param-value="התנדבות לקיץ"/>
                    <div className="checkbox-rail"><span></span></div>
                </label>}
                <div className="search-fields-wrapper">
                    {
                        props.filters?.map((item, i) => {                                         
                            switch(item.filterTypeID) {
                                case 6:
                                  return <FilterGeneric key={item.filterTypeID} updateFilter={updateFilterChoices} filter={store.tempFilters.volunteerFields} apiFilter={item} iconDiff={true} clearFilterLabel={clearFilterLabel}><HandIcon/></FilterGeneric>                                                         
                                case 1:
                                  return <FilterLocation key={item.filterTypeID} updateFilter={updateFilterChoices} cities={store.tempFilters.city} areas={store.tempFilters.area} apiFilter={item} clearFilterLabel={clearFilterLabel}></FilterLocation>  
                                // case 9:
                                //   return <FilterGeneric key={item.filterTypeID} updateFilter={updateFilterChoices} filter={store.tempFilters.commitment} apiFilter={item} clearFilterLabel={clearFilterLabel}><CommitmentIcon/></FilterGeneric>   
                                case 7:
                                  return <FilterGeneric key={item.filterTypeID} updateFilter={updateFilterChoices} filter={store.tempFilters.population} apiFilter={item} clearFilterLabel={clearFilterLabel}><HandsTogetherIcon/></FilterGeneric>  
                                // case 10:
                                //   return <FilterGeneric key={item.filterTypeID} updateFilter={updateFilterChoices} filter={store.tempFilters.campuses} apiFilter={item} clearFilterLabel={clearFilterLabel}><CampusIcon/></FilterGeneric>  
                                // case 12:
                                //   return <FilterGeneric key={item.filterTypeID} updateFilter={updateFilterChoices} filter={store.tempFilters.forGroups} apiFilter={item} clearFilterLabel={clearFilterLabel}><AmountIcon/></FilterGeneric>  
                                default:
                                  return '';
                            }
                        })
                    }
                </div>
                {/* <div className='relative filter_cross pointer' onClick={() => clearFilters()}>
                    <button type='button' className='clear_filters_btn' title="נקה סינון">
                        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M19.79 5.61C19.73 5.49 19.67 5.38 19.59 5.29L19.58 5.28C19.24 4.89 18.75 4.67 18.22 4.67H5.78C5.25 4.67 4.76 4.89 4.42 5.28L4.41 5.29C4.33 5.38 4.27 5.49 4.21 5.61C4.08 5.87 4 6.17 4 6.5V7.24C4 7.77 4.21 8.28 4.59 8.66L9 13.07V19.5C9 19.91 9.34 20.25 9.75 20.25C9.89 20.25 10.03 20.21 10.15 20.14L13.81 17.92C14.09 17.75 14.25 17.44 14.25 17.1V13.07L18.66 8.66C19.04 8.28 19.25 7.77 19.25 7.24V6.5C19.25 6.17 19.17 5.87 19.04 5.61H19.79Z" fill="#298CCA"/>
                            <path d="M18.36 2.64C18.07 2.35 17.59 2.35 17.3 2.64L2.64 17.3C2.35 17.59 2.35 18.07 2.64 18.36C2.79 18.51 2.98 18.58 3.17 18.58C3.36 18.58 3.55 18.51 3.7 18.36L18.36 3.7C18.65 3.41 18.65 2.93 18.36 2.64Z" fill="#B50072"/>
                        </svg>
                    </button>
                </div> */}
            </form>
        </div>
    </section>
    )
}
